
import vacancySearch from '~/graphql/queries/vacancySearch.gql';
import dienstverbanden from '~/graphql/queries/dienstverbanden.gql';
import specialismen from '~/graphql/queries/specialismen.gql';
import page from '~/plugins/mixins/page';
import {COUNTRIES} from '~/plugins/constants';

export default {
  auth: false,
  mixins: [page],
  apollo: {
    vacancySearch: {
      query: vacancySearch,
      variables() {
        return this.formData;
      },
      skip() {
        return !this.mounted;
      },
      result({data}) {
        if (data?.vacancySearch?.vacancies) {
          this.vacancies = data.vacancySearch.vacancies;
          this.facets = data.vacancySearch.facets;
        }

        this.locationNotFound = data?.vacancySearch?.message === 'location not found';
      },
    },
    dienstverbanden: {
      query: dienstverbanden,
    },
    specialismen: {
      query: specialismen,
    },
  },
  data() {
    return {
      showFilters: true,
      mobileFiltersOpen: false,
      mounted: false,
      formData: {},
      locationNotFound: false,
      defaultFormData: {
        aangeboden_sinds: [],
        dienstverband: [],
        land: [],
        regio: [],
        specialisme: [],
        uren: [],
        werkervaring: [],
        search: '',
        page: 1,
        per_page: '20',
        radius: '1',
      },
      dienstverbanden: [],
      specialismen: [],
      vacancies: [],
      facets: [],
      COUNTRIES,
    };
  },
  head: () => ({
    title: 'Vacatures',
  }),
  computed: {
    options() {
      const countries = COUNTRIES;
      const regions = [
        'Drenthe',
        'Flevoland',
        'Friesland',
        'Gelderland',
        'Groningen',
        'Limburg',
        'Noord-Brabant',
        'Noord-Holland',
        'Overijssel',
        'Utrecht',
        'Zeeland',
        'Zuid-Holland',
      ];
      const experiences = ['Starter', '1 tot 3 jaar', '4 tot 10 jaar'];
      const hours = [
        ['0 - 19 uur', 0, 19],
        ['20 - 31 uur', 20, 31],
        ['32 - 39 uur', 32, 39],
        ['40 uur', 40, 40],
      ];
      return {
        per_page: [5, 10, 20, 30, 50],
        radius: [
          {label: 'Alle afstanden', value: 0},
          {label: '1 km', value: 1},
          {label: '10 km', value: 10},
          {label: '20 km', value: 20},
          {label: '50 km', value: 50},
        ],
        aangeboden_sinds: [
          {label: 'Vandaag', amount: this.getFacetOptions('aangeboden_sinds', 'Vandaag'), value: this.getDate()},
          {label: 'Gisteren', amount: this.getFacetOptions('aangeboden_sinds', 'Gisteren'), value: this.getDate(-1)},
          {label: 'Deze week', amount: this.getFacetOptions('aangeboden_sinds', 'Deze week'), value: this.getDate(-7)},
        ],
        dienstverband: this.dienstverbanden.map(({title}) => title).sort().map(title => ({
          value: title, label: title, amount: this.getFacetOptions('dienstverband', title),
        })),
        land: countries.map(country => ({
          value: country, label: country, amount: this.getFacetOptions('land', country),
        })),
        regio: regions.map(region => ({
          value: region, label: region, amount: this.getFacetOptions('regio', region),
        })),
        specialisme: this.specialismen.map(({title}) => title).sort().map(title => ({
          value: title, label: title, amount: this.getFacetOptions('specialisme', title),
        })),
        uren: hours.map(hourOption => ({
          value: hourOption[1] + ' - ' + hourOption[2], label: hourOption[0], amount: this.getFacetOptions('uren', hourOption[1] + ' - ' + hourOption[2]),
        })),
        werkervaring: experiences.map(experience => ({
          value: experience, label: experience, amount: this.getFacetOptions('werkervaring', experience),
        })),
      };
    },
    areFiltersDefault() {
      let same = true;

      Object.keys(this.formData).forEach((key) => {
        if (['page', 'per_page'].includes(key)) {
          return;
        }

        let value = this.formData[key];
        if (Array.isArray(value)) {
          value = this.formData[key].filter(element => element !== undefined);
        }

        if (JSON.stringify(value) !== JSON.stringify(this.defaultFormData[key])) {
          same = false;
        }
      });

      return same;
    },
  },
  watch: {
    formData: {
      deep: true,
      handler(newData) {
        this.$apollo.queries.vacancySearch.refetch(newData);
        window.scroll({
          top: 350,
          left: 0,
          behavior: 'smooth',
        });
      },
    },
  },
  mounted() {
    this.formData = JSON.parse(JSON.stringify(this.defaultFormData));
    this.formData.specialisme = [this.$route.query?.s] ?? [];
    this.formData.regio = [this.$route.query?.r] ?? [];

    if (this.$route.query?.r || this.$route.query?.s) {
      this.$router.replace(this.localePath({name: 'vacatures'}));
    }
    this.mounted = true;
  },
  methods: {
    resetFilters() {
      this.formData = JSON.parse(JSON.stringify(this.defaultFormData));

      this.showFilters = false;
      this.$nextTick(() => {
        this.showFilters = true;
      });
    },
    getDate(subtractedDays = 0) {
      const today = new Date();
      const date = new Date(today);

      date.setDate(date.getDate() + subtractedDays);
      return date.toISOString().split('T')[0];
    },
    getFacetOptions(field, value) {
      const facet = this.facets.filter(facet => facet.field === field)[0];

      if (facet?.facets) {
        const foundValue = facet.facets.filter(facetVal => facetVal.value === value)[0];
        if (foundValue) {
          return foundValue.count;
        }
      }

      return 0;
    },
    filtersChanged() {
      this.formData.page = 1;
    },
  },
};
